import {
  Carousel,
  CarouselSlide,
  VeloTaxesCard,
  VeloLicensesCard,
  VeloComplianceCard
} from '#client/components/Carousel';
import NewYearsGiftCard from '#client/components/Carousel/Cards/NewYearsGiftCard/NewYearsGiftCard';
import { HomeSection } from '#client/components/HomeSection';

function DashboardCarousel() {
  const activeSlides = new Map([
    ['new_years_gift', <NewYearsGiftCard />],
    ['velo_taxes', <VeloTaxesCard />],
    ['velo_licenses', <VeloLicensesCard />],
    ['velo_compliance', <VeloComplianceCard />]
  ]);

  const carouselEventingProperties = {
    bannerType: 'promo',
    elementName: 'dashboard_carousel',
    elementValue: Array.from(activeSlides.keys())
  };

  return (
    <HomeSection>
      <Carousel
        autoplayDurationInSeconds={15}
        totalSlides={activeSlides.size}
        eventingProperties={carouselEventingProperties}
      >
        {Array.from(activeSlides.entries()).map(([key, slide], index) => (
          <CarouselSlide
            key={key}
            slideIndex={index}
            totalSlides={activeSlides.size}
          >
            {slide}
          </CarouselSlide>
        ))}
      </Carousel>
    </HomeSection>
  );
}

export default DashboardCarousel;
